import { setContext } from 'apollo-link-context';
import storage from 'services/storage';
import { name, version } from './../../../../../package.json';

export function getCustomHeaders() {
  // get the authentication token from local storage if it exists
  const token = window.location.pathname.includes('admin')
    ? storage.getAdminToken()
    : storage.getToken();

  const tokenFromSession = storage.getSessionToken();

  // If token is not is ls fetch from store.
  const authToken = token || tokenFromSession;

  return {
    'graphql-client-name': name,
    'graphql-client-version': version,
    ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
  };
}

// eslint-disable-next-line no-empty-pattern
export default setContext(async ({}, { headers = {}, ...rest }) => {
  // return the headers to the context so httpLink can read them
  const customHeaders = getCustomHeaders();

  return {
    ...rest,
    headers: {
      ...headers,
      ...customHeaders,
    },
  };
});
